import type { PointerEvent } from "react";
import { createPath, type To } from "history";
import {
  resolvePath,
  useLocation,
  type NavigateOptions,
} from "react-router-dom";

import { useNavigate } from "./useNavigate";
import { keepSearchParams } from "./keepSearchParams";

export const useMakeLink = () => {
  const from = useLocation();
  const navigate = useNavigate();

  return (path: To, options?: NavigateOptions, onNavigate?: () => void) => {
    const toPartialPath = resolvePath(path);
    const toSearchParams = new URLSearchParams(toPartialPath.search);
    const fromSearchParams = new URLSearchParams(from.search);

    keepSearchParams.forEach((param) => {
      const toParam = toSearchParams.get(param);
      const fromParam = fromSearchParams.get(param);
      if (!toParam && fromParam) {
        toSearchParams.set(param, fromParam);
      }
    });

    const link = createPath({
      pathname: toPartialPath.pathname,
      search: toSearchParams.toString(),
      hash: toPartialPath.hash,
    });

    return {
      href: link,
      onClick: (e: PointerEvent<HTMLAnchorElement>) => {
        if (
          e.ctrlKey ||
          e.metaKey ||
          e.altKey ||
          e.shiftKey ||
          e.button !== 0
        ) {
          return;
        }
        e.preventDefault();
        navigate(link, options);
        onNavigate?.();
      },
    };
  };
};
